import React, { Component } from "react"

import CancelModal from "./CancelModal"
import DeleteConfirmationModal from "./DeleteConfirmationModal"
import SpinnerImage from "./SpinnerImage"
import WidgetHeaderButton from "./WidgetHeaderButton"

class FormActionButtonsWidget extends Component {
    state = {
        isModalOpen: false,
        isDeleteConfirmationOpen: false
    }

    handleCancel = () => {
        if (this.props.updateModel && this.props.updateModel.size) {
            this.toggle()
        } else {
            this.props.cancel()
        }
    }

    handleConfirmCancel = () => {
        this.props.cancel()
        this.setState({ isModalOpen: false })
    }

    handleSave = () => {
        if (this.props.needsConfirmation) {
            this.toggleDeleteConfirmation()
        } else {
            this.props.save()
        }
    }

    handleConfirmDelete = () => {
        this.props.save()
        this.setState({ isDeleteConfirmationOpen: false })
    }

    toggle = () => {
        this.setState({ isModalOpen: !this.state.isModalOpen })
    }

    toggleDeleteConfirmation = () => {
        this.setState({
            isDeleteConfirmationOpen: !this.state.isDeleteConfirmationOpen
        })
    }

    render() {
        const {
            children,
            isSaving,
            isCreateMode,
            canSave,
            canCancel,
            header,
            saveDisabledTitle,
            showCancel = true,
            showSave = true
        } = this.props

        return (
            <div className="widget small-widget-padding">
                <div className="widget-header form-action-header">
                    <p>{header}</p>
                    <div className="save-buttons pull-right">
                        {isSaving && <SpinnerImage />}
                        {children}
                        {showCancel && (
                            <WidgetHeaderButton
                                isSecondary={true}
                                disabled={!canCancel || isSaving}
                                onClick={this.handleCancel}
                            >
                                Cancel
                            </WidgetHeaderButton>
                        )}
                        <CancelModal
                            isOpen={this.state.isModalOpen}
                            onConfirmCancel={this.handleConfirmCancel}
                            toggle={this.toggle}
                        />
                        <DeleteConfirmationModal
                            isOpen={this.state.isDeleteConfirmationOpen}
                            onConfirmDelete={this.handleConfirmDelete}
                            toggle={this.toggleDeleteConfirmation}
                        />
                        {showSave && (
                            <WidgetHeaderButton
                                disabled={!canSave || isSaving}
                                title={
                                    !canSave && !isSaving
                                        ? saveDisabledTitle
                                        : undefined
                                }
                                onClick={this.handleSave}
                                data-cy="createOrSaveButton"
                            >
                                {isCreateMode ? "Create" : "Save"}
                            </WidgetHeaderButton>
                        )}
                    </div>
                </div>
            </div>
        )
    }
}

export default FormActionButtonsWidget
